/**
 * LogoCompletion - Component shown when logo creation flow completes
 *
 * Horizontal banner style matching campaign-success component.
 * Shows the selected logo with a success message.
 */

import React, { FC } from 'react';
import {
  Box,
  Flex,
  Text,
  Image,
} from '@chakra-ui/react';

interface LogoCompletionProps {
  url?: string;
}

const LogoCompletion: FC<LogoCompletionProps> = ({ url = '' }) => {
  const parsedUrl = url ? String(url) : '';

  if (!parsedUrl) {
    return null;
  }

  return (
    <Flex
      w="100%"
      maxW="420px"
      bg="green.50"
      borderRadius="lg"
      border="1px solid"
      borderColor="green.200"
      p={3}
      my={2}
      align="center"
      gap={3}
    >
      {/* Success Icon */}
      <Box
        w="36px"
        h="36px"
        bg="green.500"
        borderRadius="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Box>

      {/* Text Content */}
      <Box flex={1} minW={0}>
        <Text fontSize="sm" fontWeight="semibold" color="green.800" lineHeight="short">
          Logo Created!
        </Text>
        <Text fontSize="xs" color="green.700">
          Saved to your account
        </Text>
      </Box>

      {/* Logo Preview */}
      <Box
        w="44px"
        h="44px"
        bg="white"
        borderRadius="md"
        border="1px solid"
        borderColor="green.200"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        overflow="hidden"
        p={1}
      >
        <Image
          src={parsedUrl}
          alt="Your logo"
          maxH="36px"
          maxW="36px"
          objectFit="contain"
        />
      </Box>
    </Flex>
  );
};

export default LogoCompletion;
